import React from 'react';
import { Icon } from './Icon.js';
export const IconMediaRecordFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconMediaRecordFill12.js.map